import TrafficSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficSignalSubType";

export const PERIOD_TO_TRACKING_VALUE_MAP: Record<string, string> = {
    mom: "month",
    qoq: "3months",
    yoy: "12months",
};

export enum TRACKING_FILTERS_ATTRIBUTES {
    /* News signals */
    NEWS_CATEGORIES = "signal_news_categories",

    /* Ad networks signals */
    AD_NETWORKS = "signal_ad_networks",
    AD_NETWORK_OPTION = "signal_option",

    /* Technology signals */
    TECH_OPTION = "signal_tech_option",
    TECH_TECHNOLOGIES = "signal_technologies",
    TECH_TECHNOLOGY_CATEGORIES = "signal_technologyCategories",
    TECH_TECHNOLOGY_SUB_CATEGORIES = "signal_technologySubCategories",

    /* Traffic signals */
    TRAFFIC_METRIC = "signal_traffic_metric",
    TRAFFIC_PERIOD = "signal_traffic_period",
    TRAFFIC_DIRECTION = "signal_traffic_direction",
    TRAFFIC_COUNTRY = "signal_traffic_country",
    TRAFFIC_VALUE = "signal_traffic_value",
    TRAFFIC_OPTION = "signal_traffic_option",
}

export const SIGNAL_TRAFFIC_SYB_TYPE_TO_TRACKING_VALUE: Record<TrafficSignalSubType, string> = {
    [TrafficSignalSubType.GettingTraction]: "traffic change",
    [TrafficSignalSubType.LosingTraction]: "traffic change",
    [TrafficSignalSubType.Engagement]: "engagement",
    [TrafficSignalSubType.NewMarkets]: "new markets",
};

export const TECHNOLOGY_SIGNAL_ALIAS_TO_TRACKING_VALUE: Record<string, string> = {
    "recently-installed-competitor": "recently-installed-any",
    "recently-removed-competitor": "recently-removed-any",
    "recently-installed-integration": "recently-installed-integration",
    "recently-removed-integration": "recently-removed-integration",
};
